import config from '../../../../config/config';
import { Configuration, POCApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const pocApi = new POCApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
